import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';

import { BreadcrumbService, RecoveryService } from '@library/core/services';

import { Report } from '../report';

@Component({
   selector: 'lib-recover-report',
   template: `
   <lib-loading *ngIf="!report"></lib-loading>
   <ng-container *ngIf="report">
      <lib-reports-display action="recover" [report]="report"></lib-reports-display>
   </ng-container>`,
})
export class RecoverReportComponent implements OnInit {

   report: Report;

   constructor(
      private route: ActivatedRoute,
      private router: Router,
      private recover: RecoveryService,
      private breadcrumbs: BreadcrumbService,
      private snackbar: MatSnackBar,
   ) { }

   ngOnInit(): void {
      this.breadcrumbs.newCrumb({ label: 'Reports', path: '/report' });
      this.breadcrumbs.addCrumble( 'Recover' );

      this.route.params.subscribe( params => {
         if ( !params?.id ) {
            this.back();
         }

         this.recover.recoverItem<Report>( this.route.snapshot.params?.id ).subscribe(
            r => {
               this.report = new Report({
                  name: r?.name,
                  filters: r?.filters,
                  schema: r?.schema,
               });
            },
            _ => this.back() );
      });
   }

   back() {
      this.snackbar.open( `Could not find report`, '', { duration: 5000, verticalPosition: 'bottom' });
      this.router.navigate([ 'report' ]);
   }
}
